module.exports = __webpack_public_path__ + "static/media/mobile-g.5a852d31.png";